import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import {FORM_ID, NETWORK} from '../../../../../framework/App/AppConstants';
import {APPLICATION_STATUS, PAGE_NAME} from '../../../../config/DEConstants';
import { spinnerOpen, spinnerClose } from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { updateSyncErrors, focus } from 'redux-form/lib/actions';
import {setServerData} from '../../../../../framework/store/ServerData/ServerDataActions';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';

const LOCALE_PREFIX_IBAN = 'DE/components/IBAN/IBAN';

export const submitRepaymentValues = (data, intl) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;

    dispatch(spinnerOpen());
    return axios
        .request({
            url: PAGE_NAME.REPAYMENT_PAGE,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(response => {
            dispatch(spinnerClose());
            if (_.get(response, 'data.bankAccountId')) {
                dispatch(push(PAGE_NAME.PERSONAL_INFO_PAGE));
                dispatch(setServerData({
                    // success, hide soft decline warn banner
                    isAddBankSoftDecline: false,
                }));
            } else {
                dispatch(spinnerClose());
                dispatch(setServerData({
                    decisionModel: response.data,
                    isAddBankSoftDecline: _.get(response, 'data.isAddBankSoftDecline'),
                }));

                const appStatus = _.get(response, 'data.applicationStatus');
                capeLog && capeLog(`submitRepaymentValues:de:response: applicationStatus: ${appStatus}`);

                if (appStatus === APPLICATION_STATUS.SOFT_DECLINE) {
                    const extra = {};
                    extra.ppc_status = appStatus;
                    dispatch(trackTransition('pp_credit_repaymentpage', 'prepare_pp_credit_repaymentpage', extra));
                    dispatch(updateSyncErrors(FORM_ID, {
                        'bank-info': {
                            iban: {
                                msg: intl.formatMessage({id: `${LOCALE_PREFIX_IBAN}.IBAN-invalid`}),
                                className: 'hasError'
                            }
                        }
                    }));
                    dispatch(focus(FORM_ID, 'bank-info.iban'));
                } else {
                    // Hard Decline redirect to Decision Page
                    dispatch(push(PAGE_NAME.DECISION_PAGE));
                }
            }
        })
        .catch(error => {
            capeLog && capeLog('response:error, DE_RepaymentPageFormActions,' + (error && error.message));
            dispatch(spinnerClose());
            dispatch(push(PAGE_NAME.ERROR_PAGE));
        });
};
